import React, { useEffect, useRef, useState } from "react";
import { downloadSectionsSampleCsv, downloadSubjectsSampleCsv } from "../utils/questionImportSample";
import "./SampleCsvMenu.css";

// The two filled-in samples for importing a whole test. Which one works depends on the test's
// paper structure: plain sections, or subjects that each hold sections.
export const SAMPLE_CSVS = [
  {
    key: "subjects",
    nested: true,
    icon: "bi bi-diagram-3",
    title: "Subjects → sections sample",
    file: "subjects_sections_questions_sample.csv",
    text: "Physics, Chemistry and Mathematics, each with Section A and Section B. Every row has a subject and a section column. For tests with “Subjects with sections”.",
    download: downloadSubjectsSampleCsv,
  },
  {
    key: "sections",
    nested: false,
    icon: "bi bi-layers",
    title: "Sections sample",
    file: "sections_questions_sample.csv",
    text: "Physics, Chemistry and Mathematics as plain sections. Every row has a section column. For tests with “Sections”.",
    download: downloadSectionsSampleCsv,
  },
];

// A "Sample CSV" button with both samples; the one matching this test is marked and listed first.
export default function SampleCsvMenu({ nested = false, sectionalTiming = true, className = "btn-ghost", label }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const samples = [...SAMPLE_CSVS].sort((a, b) => (b.nested === nested) - (a.nested === nested));

  return (
    <div className="sample-menu" ref={ref}>
      <button
        type="button"
        className={className}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <i className="bi bi-file-earmark-spreadsheet"></i> {label || "Sample CSV"}{" "}
        <i className={`bi bi-chevron-${open ? "up" : "down"}`}></i>
      </button>

      {open && (
        <div className="sample-menu-popover" role="menu">
          {samples.map((sample) => {
            const fits = sample.nested === nested;
            return (
              <button
                key={sample.key}
                type="button"
                role="menuitem"
                className={`sample-menu-item ${fits ? "fits" : ""}`}
                onClick={() => {
                  sample.download(sectionalTiming);
                  setOpen(false);
                }}
              >
                <i className={sample.icon}></i>
                <span>
                  <strong>
                    {sample.title}
                    {fits ? (
                      <span className="badge badge-success">For this test</span>
                    ) : (
                      <span className="badge badge-neutral">Other structure</span>
                    )}
                  </strong>
                  <small>{sample.text}</small>
                  <code>{sample.file}</code>
                </span>
                <i className="bi bi-download sample-menu-dl"></i>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
